import { BehaviorSubject, Subject } from "rxjs";

// export const pickListTypes = [
//     "Roles",
//     "ATL accounts",
//     "Accounts",
//     "Unit",
//     "Project Status",
//     "Permission",
//     "Studio",
//     "Cost summary",
//     "Creative Executives"
// ]

export interface PickListDetail{
    picklistDetailId: number;
    picklistCategoryId: number;
    value: string;
    displayOrder: number;
}

export interface PickListCategory{
    picklistCategoryId:number;
    type:string;
    typeDescription:string;
    uiFieldGroup:string;
    pickListDetailsDTOList: PickListDetail[]
}

export interface PostProdPickList{
    aspectRatio: PickListDetail[];
    cameraType: PickListDetail[];
    camera: PickListDetail[];
    frameRate: PickListDetail[];
    captureMedia: PickListDetail[];
    imageCapture: PickListDetail[];
    editorialLocation: PickListDetail[];
    editorialLocationPhase: PickListDetail[];
    resolution: PickListDetail[];
    sound: PickListDetail[];
    mpaaRating: PickListDetail[];
    ppsrRoles: PickListDetail[];
    period: PickListDetail[];
}

let PostProdPickListType=[
    {    option:"Aspect Ratio", key:'aspectRatio' },
    {    option:"Camera Type", key:'cameraType' },
    {    option:"Camera", key:'camera' },
    {    option:"Frame Rate", key:'frameRate' },
    {    option:"Capture Media", key:'captureMedia' },
    {    option:"Image Capture", key:'imageCapture' },
    {    option:"Editorial Location", key:'editorialLocation' },
    {    option:"Editorial Location Phase", key:'editorialLocationPhase' },
    {    option:"Resolution", key:'resolution' },
    {    option:"Sound", key:'sound' },
    {    option:"MPAA Rating", key:'mpaaRating' },
    {    option:"PPSR Roles", key:'ppsrRoles' },
    {    option:"Period", key:'period' },
]

export let roles = new BehaviorSubject<PickListDetail[]>([]);
export let projectStatus = new BehaviorSubject<PickListDetail[]>([]);
export let permissions = new BehaviorSubject<PickListDetail[]>([]);
export let studios = new BehaviorSubject<PickListDetail[]>([]);
export let accounts = new BehaviorSubject<PickListDetail[]>([]);
export let creativeExecutives = new BehaviorSubject<PickListDetail[]>([]);

export let PostProdPickListData = new BehaviorSubject<PostProdPickList|null>(null);


export function initializeRequiredData(pickListCategoryList: PickListCategory[]){

    let temp:any|PostProdPickList={
        aspectRatio: [],
        camera: [],
        cameraType: [],
        frameRate: [],
        captureMedia: [],
        imageCapture: [],
        editorialLocation: [],
        editorialLocationPhase: [],
        resolution: [],
        sound: [],
        mpaaRating: [],
        ppsrRoles: []
    }

    for(let p of pickListCategoryList){
        
        if(p.type=="Roles"){
            roles.next(p.pickListDetailsDTOList);
        }
        else if(p.type=="Project Status"){
            projectStatus.next(p.pickListDetailsDTOList);
        }
        else if(p.type=="Permission"){
            permissions.next(p.pickListDetailsDTOList);
        }
        else if(p.type=="Studio"){
            studios.next(p.pickListDetailsDTOList);
        }
        else if(p.type=="Accounts"){
            accounts.next(p.pickListDetailsDTOList);
        }
        else if(p.type=="Creative Executives"){
            creativeExecutives.next(p.pickListDetailsDTOList);
        }
        else{
            for(let o of PostProdPickListType){
                if(o.option==p.type){
                    temp[o.key]=p.pickListDetailsDTOList;
                    break;
                }
            }
        }

    }

    PostProdPickListData.next(temp);

}